import ClearIcon from "@mui/icons-material/Clear";
import DeleteIcon from "@mui/icons-material/Delete";
import DragHandleIcon from "@mui/icons-material/DragHandle";
import EditIcon from "@mui/icons-material/Edit";
import UploadIcon from "@mui/icons-material/Upload";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Icon,
  IconButton,
  Tooltip,
} from "@mui/material";
import {
  DataGridPro,
  GridToolbarContainer,
  GridToolbarExport,
  useGridApiRef,
} from "@mui/x-data-grid-pro";
import { LicenseInfo } from "@mui/x-license-pro";
import { Upload } from "antd";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiInput from "components/SuiInput";
import SuiTypography from "components/SuiTypography";
import Prompt, { SimplePrompt } from "components/UpStyled/Prompt";
import { nanoid } from "nanoid";
import Papa from "papaparse";
import { useEffect, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

LicenseInfo.setLicenseKey(
  "7addb1959b1b3df49bbd9c4c58ee24ceTz02MTA3NCxFPTE3MDkzMjQxODY1ODksUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI="
);
var deepEqual = require("deep-equal");
const smartdate = require("smartdate");
smartdate.init();

const SizeTable = ({ editmode, table, updateTable, deleteTable, name }) => {
  const [fields, setFields] = useState(table.fields);
  const [rows, setRows] = useState(table.rows);
  const [selectedRows, setSelectedRows] = useState([]);
  const [editColumnDialogVisible, setEditColumnDialogVisible] = useState(false);
  const [editingRowId, setEditingRowId] = useState("");
  const [promptConfig, setPromptConfig] = useState(null);

  const apiRef = useGridApiRef();

  useEffect(() => {
    setRows(table.rows);
  }, [table.rows]);

  useEffect(() => {
    setFields(table.fields);
  }, [table.fields]);

  useEffect(() => {
    setEditingRowId("");
    return () => {
      console.log("rows", rows, "editingRowId", editingRowId);
      if (editingRowId !== "") {
        //apiRef.current.startRowEditMode({ id: editingRowId, fieldToFocus: fields[1].field, deleteValue: true });
        setEditingRowId("");
      }
    };
  }, [editingRowId]);

  const EditColumns = ({ }) => {
    const [columns, setColumns] = useState(
      fields?.filter((f) => f.disableReorder !== true).map((f) => ({ ...f, editable: true }))
    );
    //console.log('fields', fields)

    const handleDrop2 = (droppedItem) => {
      if (!droppedItem.destination) return;
      var updatedList = [...columns];
      const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);
      updatedList.splice(droppedItem.destination.index, 0, reorderedItem);
      setColumns(updatedList);
    };

    return (
      <Dialog
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "720px",
              height: "700px",
            },
          },
        }}
        open={editColumnDialogVisible}
        maxWidth={"lg"}
        onClose={() => setEditColumnDialogVisible(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Edit Columns</DialogTitle>
        <DialogContent>
          <DragDropContext onDragEnd={handleDrop2}>
            <Droppable droppableId="column-container" direction="vertical">
              {(provided) => (
                <div
                  style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  {columns.map((column, index) => (
                    <Draggable
                      id={column.field}
                      key={column.field}
                      draggableId={column.field}
                      index={index}
                      isDragDisabled={column.field == "Code1"}
                    >
                      {(provided) => {
                        provided.draggableProps.style = {
                          ...provided.draggableProps.style,
                          width: "700px",
                        };
                        return (
                          <div
                            ref={provided.innerRef}
                            {...provided.dragHandleProps}
                            {...provided.draggableProps}
                          >
                            <SuiBox
                              sx={{ width: "700px", px: 1 }}
                              display="flex"
                              alignItems="center"
                              justifyContent="flex-start"
                            >
                              <DragHandleIcon fontSize="small" />
                              <SuiTypography
                                sx={{
                                  textAlign: "right",
                                  width: "100px",
                                  minWidth: "100px",
                                  whiteSpace: "nowrap",
                                }}
                                variant="body1"
                              >
                                {index + 1}. Column
                              </SuiTypography>
                              <>
                                <SuiBox sx={{ width: "400px", margin: "5px 20px" }}>
                                  <SuiInput
                                    autoFocus={column.headerName === ""}
                                    value={column.headerName}
                                    onChange={(e) => {
                                      const newDatas = columns.map((c) => {
                                        if (column.field === c.field)
                                          return { ...c, headerName: e.target.value };
                                        else return c;
                                      });
                                      setColumns(newDatas);
                                    }}
                                  />
                                </SuiBox>
                                <IconButton
                                  disabled={column.field == "Code"}
                                  size="medium"
                                  onClick={() => {
                                    const newDatas =
                                      editmode > 1
                                        ? columns.map((c) => {
                                          if (column.field === c.field)
                                            return {
                                              ...c,
                                              PEPdate: new Date(),
                                              PEPname: detail.user_name,
                                              PEProle: detail.user_id,
                                              v: c.headerName,
                                              PEPvalue: "",
                                            };
                                          else return c;
                                        })
                                        : columns.filter((c) => {
                                          return column.field !== c.field;
                                        });
                                    setColumns(newDatas);
                                  }}
                                >
                                  <Icon
                                    fontSize="medium"
                                    className="border-none hover:bg-transparent"
                                  >
                                    clear
                                  </Icon>
                                </IconButton>
                              </>
                            </SuiBox>
                          </div>
                        );
                      }}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </DialogContent>
        <DialogActions>
          <SuiButton
            onClick={() => {
              setColumns([
                ...columns,
                { field: nanoid(), headerName: "", width: 100, editable: true },
              ]);
            }}
            color={"dark"}
            variant="gradient"
          >
            Add Column
          </SuiButton>
          <div style={{ flex: "1 0 0" }} />
          <SuiButton
            onClick={() => setEditColumnDialogVisible(false)}
            color={"secondary"}
            variant="gradient"
          >
            Cancel
          </SuiButton>
          <SuiButton
            onClick={() => {
              setEditColumnDialogVisible(false);
              for (var column of columns) column.width = Math.max(50, column.width);
              var newTableFields = fields.filter((f) => f.disableReorder === true).concat(columns);
              newTableFields = resizeColumns(rows, newTableFields);
              setFields(newTableFields);
              updateTable(table.id, rows, newTableFields);
            }}
            color={"dark"}
            variant="gradient"
          >
            Update
          </SuiButton>
        </DialogActions>
      </Dialog>
    );
  };

  var toolbarColor = "#344767"; //#17c1e8 //1778D2
  var hoverColor = toolbarColor;
  var buttonconfig = {
    p: 1,
    border: "0 none",
    "&:hover": { border: "0 none", color: hoverColor, opacity: 1 },
    "&:disabled": { border: "0 none" },
    "&:focus": { border: "0 none" },
    color: toolbarColor,
  };

  const CustomToolbar = () => {
    return (
      <GridToolbarContainer>
        {editmode > 0 && (
          <Tooltip
            title="Change the order of your columns or edit their names."
            placement="top-start"
          >
            <SuiButton
              variant="outlined"
              size="medium"
              startIcon={<EditIcon />}
              sx={buttonconfig}
              onClick={() => {
                setEditColumnDialogVisible(true);
              }}
            >
              Edit Columns
            </SuiButton>
          </Tooltip>
        )}
        <GridToolbarExport
          sx={{ color: toolbarColor, px: 1, "&:hover": { color: hoverColor } }}
          printOptions={{
            disableToolbarButton: false,
            hideFooter: true,
            hideToolbar: true,
            fields: fields.filter((f) => f.field !== "+" && f.hide !== true).map((f) => f.field),
            fileName: name,
          }}
          csvOptions={{
            fileName: name,
            fields: fields.filter((f) => f.field !== "+" && f.hide !== true).map((f) => f.field),
          }}
        />
        {editmode > 0 && (
          <Tooltip title="Import from csv file" placement="top-start">
            <span>
              <Upload accept=".csv,.txt" showUploadList={false} customRequest={handleUpload}>
                <SuiButton
                  variant="outlined"
                  size="medium"
                  startIcon={<UploadIcon />}
                  sx={buttonconfig}
                >
                  Import
                </SuiButton>
              </Upload>
            </span>
          </Tooltip>
        )}
        {editmode > 0 && (
          <Tooltip title="Delete selected rows" placement="top-start">
            <span>
              <SuiButton
                disabled={selectedRows.length == 0}
                variant="outlined"
                color="secondary"
                size="medium"
                startIcon={<DeleteIcon />}
                sx={buttonconfig}
                onClick={() => {
                  setPromptConfig({
                    heading: "Delete Confirmation",
                    text: "Are you sure you want to delete selected rows?",
                    handleOk: () => {
                      var newRows = rows.filter((r) => !selectedRows.includes(r.id));
                      var newFields = resizeColumns(newRows, fields);
                      setRows(newRows);
                      setFields(newFields);
                      setSelectedRows([]);
                      updateTable(table.id, newRows, newFields);
                    },
                  });
                }}
              >
                Delete Rows
              </SuiButton>
            </span>
          </Tooltip>
        )}
        {editmode > 0 && (
          <Tooltip title="Delete whole size table" placement="top-start">
            <SuiButton
              variant="outlined"
              color="secondary"
              size="medium"
              startIcon={<ClearIcon />}
              sx={buttonconfig}
              onClick={() => {
                setPromptConfig({
                  heading: "Delete Confirmation",
                  text: "Are you sure you want to delete this table table?",
                  handleOk: () => deleteTable(table.id),
                });
              }}
            >
              Delete Table
            </SuiButton>
          </Tooltip>
        )}
      </GridToolbarContainer>
    );
  };

  const handleUpload = async ({ file }) => {
    //console.log('file', file)
    Papa.parse(file, {
      complete: function (results) {
        //console.log("Finished:", results.data);
        if (results.data.length <= 1) return;
        var fieldPos = [];
        var newFields = [...fields];
        var newRows = [...rows];
        var matchFieldIndex = -1;
        for (var header of results.data[0]) {
          var find = newFields.find((f) => f.headerName === header);
          if (find) fieldPos.push(find);
          else {
            var newField = {
              field: nanoid(),
              headerName: header,
              hide: false,
              width: 100,
              editable: true,
            };
            fieldPos.push(newField);
            newFields.push(newField);
          }
          if (fieldPos[fieldPos.length - 1] === newFields[1]) matchFieldIndex = fieldPos.length - 1;
        }
        for (var row of results.data.slice(1)) {
          if (row.every((c) => c === null || c === undefined || c === "")) break;
          var gridrow = null;
          if (matchFieldIndex >= 0 && row.length > matchFieldIndex) {
            gridrow = newRows.find((r) => r[newFields[1].field] === row[matchFieldIndex]);
          }
          if (!gridrow) {
            gridrow = { id: nanoid() };
            newRows.push(gridrow);
          }
          for (var index = 0; index < Math.min(fieldPos.length, row.length); ++index) {
            gridrow[fieldPos[index].field] = row[index];
          }
        }
        newFields = resizeColumns(newRows, newFields);
        setRows(newRows);
        setFields(newFields);
        updateTable(table.id, newRows, newFields);
      },
    });
  };

  var tableFields2 = [];
  for (const f of fields) {
    var newf = {
      ...f,
      sortable: false,
      headerName: f.headerName,
      headerAlign: "center",
      align: "center",
    };
    if (tableFields2.length === 1) {
      newf.renderCell = (params) => {
        //console.log('renderCell', params)
        if (tableRow[tableRow.length - 1].id === params.row.id)
          return (
            <SuiButton
              sx={{ mx: 1, p: 0, textTransform: "none", width: "100%" }}
              size="medium"
              variant="text"
              color="dark"
              onClick={(e) => {
                e.stopPropagation();
                var rowid = nanoid();
                var rows2 = [...rows, { id: rowid }];
                setRows(rows2);
                setEditingRowId(rowid);
              }}
            >
              ADD ROW
            </SuiButton>
          );
        return params.value;
      };
      newf.width = Math.max(newf.width, 100);
    }
    tableFields2.push(newf);
  }
  tableFields2.push({
    hide: false,
    sortable: false,
    field: "+",
    headerName: editmode > 0 ? "+" : "",
    width: 64,
    disableReorder: true,
    editable: false,
    headerAlign: "center",
  });

  var tableRow = [...rows, { id: nanoid() }];
  tableRow = tableRow.map((r) => {
    return { ...r, __reorder__: r.Size ?? " " };
  });

  function maxOfCol(newRows, col) {
    var columnDatas = [col.headerName];
    for (var line of newRows) {
      var cell = line[col.field];
      if (cell !== null && cell !== undefined) columnDatas.push(cell);
    }
    let invisibleContainer = document.createElement("div");
    invisibleContainer.style.visibility = "hidden";
    invisibleContainer.style.zIndex = "-9999999999";
    invisibleContainer.style.position = "absolute";
    invisibleContainer.style.fontSize = "16px";
    invisibleContainer.style.top = "0";
    invisibleContainer.style.left = "0";
    document.body.append(invisibleContainer);
    let widths = [];
    columnDatas.forEach((cell) => {
      let invisibleCell = document.createElement("div");
      invisibleCell.innerHTML = cell;
      invisibleCell.style.width = "max-content";
      invisibleCell.style.maxWidth = "none";
      invisibleCell.style.minWidth = "none";
      invisibleContainer.append(invisibleCell);
      widths.push(Math.ceil(invisibleCell.clientWidth));
      invisibleContainer.style.fontSize = "14px";
    });
    let max = Math.max(...widths);
    invisibleContainer.remove();
    return max;
  }

  function resizeColumns(newRows, newFields) {
    let cols = [];
    newFields.forEach((col) => {
      let maxColWidth = maxOfCol(newRows, col);
      cols.push({ ...col, width: Math.max(maxColWidth + 26, 64) });
    });
    return cols;
  }

  return (
    <SuiBox sx={{ height: "auto", overflowY: "hidden", width: "100%", mt: 5 }}>
      <EditColumns />
      <SimplePrompt promptConfig={promptConfig} setPromptConfig={setPromptConfig} />
      <DataGridPro
        apiRef={apiRef}
        autoHeight
        rowReordering={editmode > 0}
        experimentalFeatures={{ newEditingApi: true }}
        checkboxSelection
        disableColumnMenu
        hideFooterPagination
        hideFooter
        disableSelectionOnClick
        showCellRightBorder
        showColumnRightBorder
        //disableColumnReorder
        disableColumnResize
        density="compact"
        editMode="row"
        isCellEditable={(params) => {
          //console.log('params', params.row.id)
          return editmode !== 0;
        }}
        selectionModel={selectedRows}
        onSelectionModelChange={(model) => {
          setSelectedRows(model);
        }}
        columns={tableFields2}
        rows={tableRow}
        components={{ Toolbar: CustomToolbar }}
        sx={{
          "@media print": {
            ".MuiDataGrid-main": {
              fontSize: "14px",
            },
            marginBottom: 1000,
          },
          "& .MuiDataGrid-cell": {
            fontSize: "14px",
          },
          "& .MuiInputBase-root": {
            border: "none",
            outline: "none",
          },
          "& .MuiInputBase-input": {
            border: "none",
            outline: "none",
          },
          "& .MuiDataGrid-columnHeader": {
            fontSize: "16px",
          },
          "& .MuiDataGrid-row.Mui-selected": {
            backgroundColor: "rgba(25, 118, 210, 0.08)",
          },
          "& .MuiDataGrid-cell:focus": {
            outline: "none",
          },
          "& .MuiDataGrid-cellCheckbox:focus": {
            outline: "none",
          },
          "& .MuiDataGrid-columnHeader:focus": {
            outline: "none",
          },
          "& .MuiDataGrid-cell.MuiDataGrid-cell--editing:focus-within": {
            outline: "none",
          },
          "& .MuiDataGrid-columnHeaderTitleContainerContent": {
            paddingBottom: "1px",
          },
          "& .MuiDataGrid-main": {
            borderTop: "1px solid rgba(224, 224, 224, 1)",
          },
        }}
        onProcessRowUpdateError={(err) => {
          console.log("err", err);
        }}
        processRowUpdate={(newRow, oldRow) => {
          var newRows = [];
          if (rows.find((r) => r.id === newRow.id)) {
            newRows = rows.map((r) => {
              return r.id === newRow.id ? newRow : r;
            });
          } else {
            if (
              Object.entries(newRow).filter(
                ([n, v]) => n !== "id" && n !== "__reorder__" && v !== undefined && v !== ""
              ).length === 0
            )
              return newRow;
            newRows = [...rows, newRow];
          }
          var newFields = resizeColumns(newRows, fields);
          setRows(newRows);
          setFields(newFields);
          updateTable(table.id, newRows, newFields);
          //console.log('rows', rows, 'newRows', newRows)
          return newRow;
        }}
        onCellClick={(params, event) => {
          //console.log('onCellClick', params)
          if (editmode == 0) return;
          if (params.colDef.editable === false) return;
          if (apiRef.current.getRowMode(params.id) === "view") {
            //console.log('onCellClick2', params)
            apiRef.current.startRowEditMode({ id: params.id, field: params.colDef.field });
            event.defaultMuiPrevented = true;
          }
        }}
        onColumnHeaderClick={(params, event, details) => {
          if (editmode == 0) return;
          //console.log('onColumnHeaderClick', params)
          if (params.field === "+") setEditColumnDialogVisible(true);
        }}
        onColumnOrderChange={(params, event, details) => {
          //console.log('onColumnOrderChange', params)
          var tableFields2 = JSON.parse(JSON.stringify(fields));
          const x = tableFields2.splice(params.oldIndex - 2, 1);
          tableFields2.splice(params.targetIndex - 2, 0, x[0]);
          setFields(tableFields2);
          updateTable(table.id, rows, tableFields2);
        }}
        onRowOrderChange={(params, event, details) => {
          //console.log('onRowOrderChange', params, 'event', event, 'details', details)
          var rows2 = JSON.parse(JSON.stringify(rows));
          if (params.oldIndex >= rows.length || params.targetIndex >= rows.length) {
            rows2 = JSON.parse(JSON.stringify(tableRow));
          }
          const x = rows2.splice(params.oldIndex, 1);
          rows2.splice(params.targetIndex, 0, x[0]);
          setRows(rows2);
          updateTable(table.id, rows2, fields);
        }}
      />
    </SuiBox>
  );
};

export default SizeTable;
